
  import createMeisterIcons from '../src/createMeisterIcons';

  const SearchB = createMeisterIcons("search-b", [["path",{"fill":"currentColor","d":"M11.175 19.175a8 8 0 1 0 0-16 8 8 0 0 0 0 16","key":"5d43e57e607e812e0deedd9d5400df5052b905da","fillRule":"evenodd","clipRule":"evenodd"}],["path",{"fill":"currentColor","d":"M16.045 16.045a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 0 1-1.06 1.06l-3.5-3.5a.75.75 0 0 1 0-1.06","key":"15ab3e0dbe8f54f37419d9d101b5568af1d889b2","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default SearchB
  